import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import hero from "../assets/h1.jpeg";
import backgroundImage from "../assets/background.jpg"; // Placeholder for background image
import {
  FaWhatsapp,
  FaStar,
  FaLaptopCode,
  FaComments,
  FaShieldAlt,
} from "react-icons/fa";

// Import course images
import datascience from "../assets/course/datascience.jpg";
import devops from "../assets/course/devops.jpeg";
import django from "../assets/course/django.jpg";
import flutter from "../assets/course/flutter.png";
import mern from "../assets/course/mern.png";
import python from "../assets/course/python.png";
import uiux from "../assets/course/uiux.jpg";
import webdev from "../assets/course/webdev.png";
import reactnative from "../assets/course/reactnative.png";
import java from "../assets/course/java.png";
import digitalmarketing from "../assets/course/digitalmarketing.jpg";
import ai from "../assets/course/ai.png";
import rhcsa from "../assets/course/rhcsa.jpeg";
import rhce from "../assets/course/rhce.png";
import oracle from "../assets/course/oracle.png";
import aiml from "../assets/course/aiml.png";
import ccna from "../assets/course/ccna.jpg";
import ccnp from "../assets/course/ccnp.jpg";

// Import classroom images
import classroom1 from "../assets/classroom/1.jpeg";
import classroom2 from "../assets/classroom/2.jpeg";
import classroom3 from "../assets/classroom/3.jpeg";
import classroom4 from "../assets/classroom/4.jpeg";
import classroom5 from "../assets/classroom/5.jpeg";
import classroom6 from "../assets/classroom/6.jpeg";

const Home = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  // Handle scroll event to detect if user has scrolled down
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Calculate number of visible cards and set --step-width for courses carousel
  useEffect(() => {
    const updateStepWidth = () => {
      const isMobile = window.innerWidth < 640;
      let numCards;

      if (isMobile) {
        numCards = Math.floor((window.innerWidth - 12) / (200 + 12));
        numCards = Math.max(numCards, 2);
        const stepWidth = numCards * (200 + 12);
        document
          .querySelector(".animate-scroll")
          .style.setProperty("--step-width", `${stepWidth}px`);
      } else {
        numCards = Math.floor((window.innerWidth - 32) / (300 + 16));
        numCards = Math.max(numCards, 2);
        const stepWidth = numCards * (300 + 16);
        document
          .querySelector(".animate-scroll")
          .style.setProperty("--step-width", `${stepWidth}px`);
      }
    };

    updateStepWidth();
    window.addEventListener("resize", updateStepWidth);
    return () => window.removeEventListener("resize", updateStepWidth);
  }, []);

  // Course data for the carousel
  const courses = [
    {
      title: "Full Stack MERN",
      duration: "45 days",
      image: mern,
      path: "/courses/full-stack-mern",
    },
    {
      title: "React Native",
      duration: "45 days",
      image: reactnative,
      path: "/courses/react-native",
    },
    {
      title: "Python",
      duration: "30 days",
      image: python,
      path: "/courses/python",
    },
    {
      title: "Data Science",
      duration: "30 days",
      image: datascience,
      path: "/courses/data-science",
    },
    {
      title: "Django",
      duration: "45 days",
      image: django,
      path: "/courses/django",
    },
    {
      title: "DevOps",
      duration: "30 days",
      image: devops,
      path: "/courses/devops",
    },
    {
      title: "Flutter App Development",
      duration: "45 days",
      image: flutter,
      path: "/courses/flutter-app-development",
    },
    {
      title: "UI/UX Design",
      duration: "30 days",
      image: uiux,
      path: "/courses/uiux-design",
    },
    {
      title: "Frontend Web Development",
      duration: "30 days",
      image: webdev,
      path: "/courses/frontend-web-development",
    },
    {
      title: "Full Stack Java",
      duration: "30 days",
      image: java,
      path: "/courses/full-stack-java",
    },
    {
      title: "Digital Marketing",
      duration: "30 days",
      image: digitalmarketing,
      path: "/courses/digital-marketing",
    },
    {
      title: "AI",
      duration: "30 days",
      image: ai,
      path: "/courses/ai",
    },
    {
      title: "RHCSA",
      duration: "45 days",
      image: rhcsa,
      path: "/courses/rhcsa",
    },
    {
      title: "RHCE",
      duration: "45 days",
      image: rhce,
      path: "/courses/rhce",
    },
    {
      title: "Oracle",
      duration: "45 days",
      image: oracle,
      path: "/courses/oracle",
    },
    {
      title: "AI & ML",
      duration: "60 days",
      image: aiml,
      path: "/courses/aiml",
    },
    {
      title: "CCNA",
      duration: "30 days",
      image: ccna,
      path: "/courses/ccna",
    },
    {
      title: "CCNP",
      duration: "45 days",
      image: ccnp,
      path: "/courses/ccnp",
    },
  ];

  // Testimonial data
  const testimonials = [
    {
      name: "Aarav Sharma",
      role: "MERN Stack Student",
      quote:
        "The MERN course transformed my career! Hands-on projects and expert mentors helped me secure a developer role.",
      rating: 5,
    },
    {
      name: "Priya Thapa",
      role: "Python Learner",
      quote:
        "Python was intimidating, but the clear lessons and community support made me confident in just 30 days!",
      rating: 4,
    },
    {
      name: "Rohan Gurung",
      role: "Data Science Student",
      quote:
        "The Data Science course gave me practical skills to analyze data and land a job in analytics!",
      rating: 5,
    },
    {
      name: "Sneha Rai",
      role: "Frontend Developer",
      quote:
        "Frontend Web Development was engaging and project-based, helping me build a portfolio that impressed employers.",
      rating: 4,
    },
  ];

  // Classroom images data
  const classroomImages = [
    { src: classroom1, alt: "Classroom Environment 1" },
    { src: classroom2, alt: "Classroom Environment 2" },
    { src: classroom3, alt: "Classroom Environment 3" },
    { src: classroom4, alt: "Classroom Environment 4" },
    { src: classroom5, alt: "Classroom Environment 5" },
    { src: classroom6, alt: "Classroom Environment 6" },
  ];

  const handleReadMore = (path) => {
    navigate(path);
  };

  return (
    <div
      className="text-white font-sans"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundRepeat: "no-repeat",
        // Fallback gradient if image fails
        backgroundColor: "#1e3a8a",
        background: `linear-gradient(135deg, rgba(30, 58, 138, 0.8), rgba(6, 182, 212, 0.8)), url(${backgroundImage})`,
      }}
    >
      {/* Hero Section */}
      <section className="relative p-6 md:p-12 min-h-[80vh] flex items-center bg-black/30 backdrop-blur-sm">
        <div className="grid grid-cols-1 md:grid-cols-[2fr_1fr] items-center gap-8 max-w-7xl mx-auto">
          <div className="space-y-6 z-10">
            <h1 className="text-5xl md:text-7xl font-black tracking-wider animate-fade-in">
              <span className="text-white">Pathway to Excellence</span>
              <span className="block text-yellow-400 mt-2">Starts Now</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-200 max-w-lg">
              Join Biratnagar’s Premier Coding Community
            </p>
            <button
              onClick={() => handleReadMore("/courses")}
              className="bg-yellow-400 text-blue-900 py-3 px-8 rounded-lg font-semibold hover:bg-yellow-500 transform hover:scale-105 transition-all duration-300 shadow-md flex items-center"
            >
              Explore Courses
            </button>
          </div>
          <div className="relative">
            <img
              src={hero}
              alt="Hero Image"
              className="w-full h-auto object-cover rounded-2xl border-4 border-yellow-400 shadow-xl transition-all duration-300 hover:scale-102 z-10"
            />
          </div>
        </div>
      </section>

      {/* Courses Carousel Section */}
      <section className="bg-gray-50 p-6 md:p-8">
        <div className="max-w-7xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900">
            Our Featured Courses
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Dive into tech with courses crafted to build real-world skills and
            boost your career.
          </p>
          <div className="relative overflow-hidden">
            <div
              className="flex animate-scroll space-x-4 md:space-x-6"
              style={{ minWidth: "max-content" }}
            >
              {courses.map((course, index) => (
                <div
                  key={index}
                  className="bg-white text-blue-900 p-4 rounded-xl shadow-md min-w-[200px] sm:min-w-[300px] flex-shrink-0 hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer border border-gray-100"
                  onClick={() => handleReadMore(course.path)}
                >
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-32 sm:h-44 object-cover rounded-lg"
                  />
                  <div className="p-4">
                    <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                      {course.title}
                    </h3>
                    <p className="text-gray-600 mt-2 text-sm md:text-base">
                      Duration: {course.duration}
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReadMore(course.path);
                      }}
                      className="mt-3 w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 text-sm md:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              ))}
              {courses.map((course, index) => (
                <div
                  key={`duplicate-${index}`}
                  className="bg-white text-blue-900 p-4 rounded-xl shadow-md min-w-[200px] sm:min-w-[300px] flex-shrink-0 hover:shadow-lg hover:scale-105 transition-all duration-300 cursor-pointer border border-gray-100"
                  onClick={() => handleReadMore(course.path)}
                >
                  <img
                    src={course.image}
                    alt={course.title}
                    className="w-full h-32 sm:h-44 object-cover rounded-lg"
                  />
                  <div className="p-4">
                    <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                      {course.title}
                    </h3>
                    <p className="text-gray-600 mt-2 text-sm md:text-base">
                      Duration: {course.duration}
                    </p>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        handleReadMore(course.path);
                      }}
                      className="mt-3 w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200 text-sm md:text-base"
                    >
                      Learn More
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="p-6 md:p-12 bg-black/30 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-10">
            Why Learn With Us?
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              {
                icon: (
                  <FaLaptopCode className="text-yellow-400 text-3xl transition-transform duration-300 hover:scale-110" />
                ),
                title: "Hands-On Learning",
                desc: "Live and recorded classes with expert instructors for practical skills.",
              },
              {
                icon: (
                  <FaComments className="text-yellow-400 text-3xl transition-transform duration-300 hover:scale-110" />
                ),
                title: "Active Community",
                desc: "Connect with peers via WhatsApp and Viber groups for support.",
              },
              {
                icon: (
                  <FaShieldAlt className="text-yellow-400 text-3xl transition-transform duration-300 hover:scale-110" />
                ),
                title: "Hassle-Free Start",
                desc: "7-day refund policy ensures a risk-free learning experience.",
              },
            ].map((feature, index) => (
              <div
                key={index}
                className="bg-white/10 backdrop-blur-md p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300"
              >
                <div className="flex justify-center mb-4">{feature.icon}</div>
                <h3 className="text-xl font-semibold text-white text-center">
                  {feature.title}
                </h3>
                <p className="text-gray-200 text-center mt-2 text-sm md:text-base">
                  {feature.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Classroom Section with Sliding Effect */}
      <section className="bg-gray-50 p-6 md:p-12">
        <div className="max-w-7xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900">
            Our Classroom Environment
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore our modern, collaborative classrooms designed to inspire
            learning and innovation.
          </p>
          <div className="relative overflow-hidden">
            <div
              className="flex animate-classroom-slide"
              style={{ minWidth: "max-content" }}
              role="region"
              aria-label="Classroom images carousel"
            >
              {classroomImages.map((image, index) => (
                <div
                  key={index}
                  className="relative bg-white rounded-2xl shadow-md min-w-[250px] sm:min-w-[350px] flex-shrink-0 mx-2 md:mx-3"
                  style={{
                    backgroundColor: "#F9FAFB",
                    border: "2px solid #1E3A8A",
                    boxShadow:
                      "0 6px 20px rgba(0, 0, 0, 0.08), 0 0 8px rgba(59, 130, 246, 0.15)",
                  }}
                >
                  <div
                    className="relative rounded-xl overflow-hidden"
                    style={{
                        boxShadow: "inset 0 0 20px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-64 sm:h-80 object-cover object-center"
                      style={{
                        filter: "brightness(1.1) contrast(1.05) saturate(1.2)",
                      }}
                    />
                  </div>
                </div>
              ))}
              {classroomImages.map((image, index) => (
                <div
                  key={`duplicate-${index}`}
                  className="relative bg-white rounded-2xl shadow-md min-w-[250px] sm:min-w-[350px] flex-shrink-0 mx-2 md:mx-3"
                  style={{
                    backgroundColor: "#F9FAFB",
                    border: "2px solid #1E3A8A",
                    boxShadow:
                      "0 6px 20px rgba(0, 0, 0, 0.08), 0 0 8px rgba(59, 130, 246, 0.15)",
                  }}
                >
                  <div
                    className="relative rounded-xl overflow-hidden"
                    style={{
                        boxShadow: "inset 0 0 20px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    <img
                      src={image.src}
                      alt={image.alt}
                      className="w-full h-64 sm:h-80 object-cover object-center"
                      style={{
                        filter: "brightness(1.1) contrast(1.05) saturate(1.2)",
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="bg-gray-100 p-6 md:p-12">
        <div className="max-w-7xl mx-auto text-center space-y-8">
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900">
            Student Success Stories
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((testimonial, index) => (
              <div
                key={index}
                className="bg-blue-50 p-6 rounded-xl shadow-inner hover:shadow-lg hover:scale-102 transition-all duration-300 border border-yellow-600/30"
                style={{
                  backgroundImage: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABYSURBVFhH7c6xCQBAAATB6b0gBiZoW5WjW5Ag2Jfv+58kSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkSZIkX8AfW6UNu8vTtwAAAABJRU5ErkJggg==')`,
                  backgroundBlendMode: "overlay",
                  backgroundSize: "20px 20px",
                }}
              >
                <div className="flex justify-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar key={i} className="text-yellow-400 text-lg" />
                  ))}
                </div>
                <p className="text-gray-600 italic mb-4 text-sm md:text-base">
                  "{testimonial.quote}"
                </p>
                <h3 className="text-lg font-semibold text-blue-900">
                  {testimonial.name}
                </h3>
                <p className="text-sm text-gray-500">{testimonial.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Course Promo Section */}
      <section className="p-6 md:p-12 bg-black/30 backdrop-blur-sm text-white">
        <div className="max-w-7xl mx-auto text-center space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold text-yellow-400 flex items-center justify-center animate-bell">
            Limited Time Offer{" "}
            <span className="text-yellow-400 text-2xl ml-2">🏆</span>
          </h2>
          <h3 className="text-xl md:text-2xl font-semibold">
            Data Science or Full Stack
          </h3>
          <p className="text-base md:text-lg max-w-xl mx-auto">
            Master Data Science or Full Stack from expert-led training, from
            basics to advanced.
          </p>
          <button
            onClick={() => navigate("/join-class")}
            className="bg-yellow-400 text-blue-900 px-8 py-3 rounded-lg font-semibold hover:bg-yellow-500 transition-all duration-300 shadow-md"
          >
            Join Now
          </button>
        </div>
      </section>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/9779849489441"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-green-500 text-white p-3 rounded-full shadow-lg hover:bg-green-600 hover:scale-110 transition-all duration-300 z-50"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp className="w-6 h-6 animate-spin-slow" />
      </a>

      {/* Inline CSS for animations */}
      <style>
        {`
          :root {
            --card-width-mobile: 250px;
            --card-width-desktop: 350px;
            --gap-mobile: 8px;
            --gap-desktop: 12px;
            --animation-duration: 24s;
          }

          @keyframes bell {
            0% { transform: translateX(0); }
            25% { transform: translateX(15px); }
            75% { transform: translateX(-15px); }
            100% { transform: translateX(0); }
          }

          .animate-bell {
            animation: bell 2s ease-in-out infinite;
          }

          @keyframes fade-in {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }

          .animate-fade-in {
            animation: fade-in 1s ease-out forwards;
          }

          @keyframes scroll {
            0%, 8.89% { transform: translateX(0); }
            10.67% { transform: translateX(calc(-1 * var(--step-width))); }
            20%, 28.89% { transform: translateX(calc(-1 * var(--step-width))); }
            30.67% { transform: translateX(calc(-2 * var(--step-width))); }
            40%, 48.89% { transform: translateX(calc(-2 * var(--step-width))); }
            50.67% { transform: translateX(calc(-3 * var(--step-width))); }
            60%, 68.89% { transform: translateX(calc(-3 * var(--step-width))); }
            70.67% { transform: translateX(calc(-4 * var(--step-width))); }
            80%, 88.89% { transform: translateX(calc(-4 * var(--step-width))); }
            90.67% { transform: translateX(calc(-5 * var(--step-width))); }
            100% { transform: translateX(calc(-5 * var(--step-width))); }
          }

          .animate-scroll {
            display: flex;
            animation: scroll 45s linear infinite;
            transition: transform 0.8s ease-in-out;
            --step-width: 1232px;
          }

          .animate-scroll:hover {
            animation-play-state: paused;
          }

          .animate-scroll:not(:hover) {
            animation-play-state: running;
          }

          @keyframes classroom-slide {
            0% { transform: translateX(0) rotateY(0deg); opacity: 1; }
            16.67% { transform: translateX(calc(-1 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            20% { transform: translateX(calc(-1 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(90deg); opacity: 0; }
            20.01% { transform: translateX(calc(-2 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(-90deg); opacity: 0; }
            23.34% { transform: translateX(calc(-2 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            33.34% { transform: translateX(calc(-2 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            36.67% { transform: translateX(calc(-3 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            40% { transform: translateX(calc(-3 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(90deg); opacity: 0; }
            40.01% { transform: translateX(calc(-4 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(-90deg); opacity: 0; }
            43.34% { transform: translateX(calc(-4 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            53.34% { transform: translateX(calc(-4 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            56.67% { transform: translateX(calc(-5 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            60% { transform: translateX(calc(-5 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(90deg); opacity: 0; }
            60.01% { transform: translateX(calc(-6 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(-90deg); opacity: 0; }
            63.34% { transform: translateX(calc(-6 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            73.34% { transform: translateX(calc(-6 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            76.67% { transform: translateX(calc(-7 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(0deg); opacity: 1; }
            80% { transform: translateX(calc(-7 * (var(--card-width-mobile) + var(--gap-mobile)))) rotateY(90deg); opacity: 0; }
            80.01% { transform: translateX(0) rotateY(-90deg); opacity: 0; }
            83.34% { transform: translateX(0) rotateY(0deg); opacity: 1; }
            100% { transform: translateX(0) rotateY(0deg); opacity: 1; }
          }

          .animate-classroom-slide {
            display: flex;
            animation: classroom-slide var(--animation-duration) linear infinite;
            transform-style: preserve-3d;
            perspective: 1000px;
          }

          .animate-classroom-slide:hover {
            animation-play-state: paused;
          }

          .animate-classroom-slide:not(:hover) {
            animation-play-state: running;
          }

          @keyframes spin-slow {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          .animate-spin-slow {
            animation: spin-slow 4s linear infinite;
          }

          @media (min-width: 640px) {
            .animate-classroom-slide {
              animation: classroom-slide var(--animation-duration) linear infinite;
            }

            .animate-classroom-slide > div {
              min-width: var(--card-width-desktop);
              width: var(--card-width-desktop);
              margin-right: var(--gap-desktop);
            }

            .animate-classroom-slide > div img {
              height: 20rem;
            }
          }

          @media (max-width: 640px) {
            .animate-scroll {
              animation: scroll 30s linear infinite;
              --step-width: 424px;
            }

            .animate-scroll > div {
              min-width: 200px;
              width: 200px;
              margin-right: 12px;
            }

            .animate-scroll > div img {
              height: 120px;
            }

            .animate-scroll > div h3 {
              font-size: 1rem;
            }

            .animate-scroll > div p {
              font-size: 0.875rem;
            }

            .animate-scroll > div button {
              font-size: 0.875rem;
              padding: 0.5rem;
            }

            .animate-classroom-slide > div {
              min-width: var(--card-width-mobile);
              width: var(--card-width-mobile);
              margin-right: var(--gap-mobile);
            }

            .animate-classroom-slide > div img {
              height: 16rem;
            }
          }
        `}
      </style>
    </div>
  );
};

export default Home;
